import React, { useState, useLayoutEffect, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FullWithModal from '@components/common/Modal/FullWidthModal';
import StageComp from '@components/Stage/indexCopy';
import Loader from '@components/common/Loader/newLoaderModal';
import KeyboardForOrder from '@components/OrderMenuTopScreen/keyboardForOrderMenuCopy';
import Modal from '@components/common/Modal';
import {
  addToStage, deleteStage, setConfirmStageSplit, renameToStage
} from '@reducers/stage';
import {
  moveChecks, updateChecksAfterResponse
} from '@reducers/storeChecks';
import {
  updateWithPaymentStages,
  removeWithPaymentStages,
  setSeat,
  setPosition,
  seatClear,
  updateSeatInfo,
  addChecks,
  replaceCart,
} from '@reducers/orders';
import { occupySeat } from '@reducers/checks';

import { setNotification, stopNotificationSound, setErrorPopUp } from '@reducers/notification';
import { flowType } from '@utility/userInfo';
import { getObjectValue } from '@utility/utills';
import { sort } from '@utility/helperFunction';
import {
  differenceWith, isEqual, findIndex, isEmpty, filter, find,
} from 'lodash';
import { APP_CONFIG, COUNTRY_CODE } from '@constants';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import { ReactComponent as Cross } from '@assets/images/cross.svg';
import cn from 'classnames';
import style from '@components/Stage/stage.module.scss';

const Stage = (props) => {

  // Props Destructuring
  const { serverAppTheme, seat } = props

  // State Management

  const currencySymbol = LABEL().CURRENCY_SYMBOL;
  const countryCode = getObjectValue(() => COUNTRY_CODE[props.auth.country].dialCode, '1');
  const [seatList, setSeatList] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isSeatDeleteModal, setSeatDeleteModal] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [availableSeats, setAvailableSeats] = useState([]);
  const [tempObject, setTempObject] = useState(null);
  const [isMoveModalOpen, setMoveModalOpen] = useState(false);
  const [selectedSeats, setSelectedSeats] = useState([]);
  const [cardIndex, setCardIndex] = useState([]);
  const [selectedStage, setSelectedStage] = useState('');
  const [selectedItem, setSelectedItem] = useState({});
  const [tableData, setTableData] = useState({});
  const [isConfirmStageSplitModal, setIsConfirmStageSplitModal] = useState(false);
  const [isStageModalOpen, setStageIsModalOpen] = useState(false);
  const [isClearPopUp, setClearPopUp] = useState({ isOpen: false, data: {} });
  const [loader, setLoader] = useState(false);
  const [isConfirmSplit, setIsConfirmSplit] = useState(false);
  const [selectedSeat, setSelectedSeat] = useState();

  // React Hooks


  useLayoutEffect(() => {
    if (isEmpty(props.position)) {
      const position = props.seat.seats.length > 0 ? props.seat.seats[0] : { number: -1, position: -1 };
      props.setPosition(position);
    }
  }, []);


  useEffect(() => {
    setTableData({
      paymentStages: seatItemHashTable,
      seats: seat.seats.reduce((a, v) => { a.push(v); return a; }, []),
      stageItemsArray: paymentStageItemsArrayWithSplitValue.flat(1)
    });
  }, [seat]);


  useEffect(() => {
    const occupiedSeats = reqSeatIds(props.seat?.paymentStages);
    setAvailableSeats(occupiedSeats.flat());
  }, [props.seat]);



  const seatItemHashTable = {};
  let priorTotalAmount = 0;

  // Methods

  const getTotalAmount = (amount) => {
    return Number(amount) > 0 ? +(amount).toFixed(2) : 0;
  };

  const isAllSeatsStaged = (() => {
    const seatIds = seat.seats.reduce((a, v) => {
      if (v.open) {
        a.push(v.id);
      }
      return a;
    }, []);
    const paymentStagesSeats = seat.paymentStages.reduce((a, v) => {
      if (v.status === 0 && v?.seats?.length > 0) {
        v.seats.forEach(({ seatId }) => a.push(seatId));
      }
      return a;
    }, []);
    return paymentStagesSeats.length === seatIds.length;
  })();
  const paymentStageItemsArrayWithSplitValue = [];
  seat.paymentStages.forEach((paymentStageData, i) => {
    const itemsArray = [];
    let subTotalAmount = 0;
    let serviceChargeAmount = 0;
    let discountAmount = 0;
    seat.items.forEach((it) => {
      let price = 0;
      let flag = false;
      let count = 0;
      paymentStageData.seats.forEach((nSeat) => {
        const index = findIndex(it.seats, (d) => d.seatId === nSeat.seatId);
        if (index !== -1) {
          flag = true;
          count += 1;
          price += it.seats[index].splitAmount;
        }
      });
      if (flag) {
        subTotalAmount += price;
        itemsArray.push({
          ...it,
          isCheck: false,
          oldPrice: it.price,
          price,
          splitValueString: count === it.seats.length ? '' : `${count}/${it.seats.length} `,
          splitValue: count === it.seats.length ? 1 : count + 1
        });
      }
    });
    paymentStageItemsArrayWithSplitValue.push(itemsArray);
    seat.serviceCharges.forEach((serviceCharge) => {
      let serviceChargeValue = 0;
      let flag = false;
      paymentStageData.seats.forEach((nSeat) => {
        const index = findIndex(serviceCharge.seats, (d) => d.seatId === nSeat.seatId);
        if (index !== -1) {
          flag = true;
          serviceChargeValue += serviceCharge.seats[index].splitAmount;
          itemsArray.push({
            ...serviceCharge, menuItemName: serviceCharge.serviceChargeName, price: serviceCharge.seats[index].splitAmount, service: true
          });
        }
      });
      if (flag) {
        serviceChargeAmount += serviceChargeValue;
      }
    });
    seat.discounts.forEach((discount) => {
      let discountValue = 0;
      let flag = false;
      paymentStageData.seats.forEach((nSeat) => {
        const index = findIndex(discount.seats, (d) => d.seatId === nSeat.seatId);
        if (index !== -1) {
          flag = true;
          discountValue += discount.seats[index].splitAmount;
          itemsArray.push({
            ...discount, menuItemName: discount.discountName, price: discount.seats[index].splitAmount, discount: true
          });
        }
      });
      if (flag) {
        discountAmount += discountValue;
      }
    });
    const taxAmt = +((subTotalAmount * seat.taxAmount) / seat.itemAmount);
    const lastStageTaxAmount = +(seat?.unpaidAmount - priorTotalAmount - subTotalAmount + discountAmount);
    const taxAmount = isAllSeatsStaged && i === (seat.paymentStages.length - 1) && lastStageTaxAmount > 0 ? +lastStageTaxAmount : +(taxAmt);
    const totalAmount = countryCode === '44' ? getTotalAmount(+(subTotalAmount + serviceChargeAmount - discountAmount)) : getTotalAmount(+(taxAmount + subTotalAmount + serviceChargeAmount - discountAmount));
    if (paymentStageData.status === 0) {
      priorTotalAmount += totalAmount;
    }
    seatItemHashTable[paymentStageData.id] = {
      paymentStageId: paymentStageData.id,
      items: itemsArray,
      taxAmount,
      subTotalAmount,
      ...paymentStageData,
      totalAmount,
      unpaidAmount: +((taxAmount + subTotalAmount + serviceChargeAmount) - discountAmount).toFixed(2),
      paidAmount: 0,
      serviceChargeAmount: +(serviceChargeAmount).toFixed(2),
      discountAmount: +(discountAmount).toFixed(2),
    };
  });
  const reqSeatIds = (array) => {
    return array.map((e) => {
      return e.seats && e.seats.map((d) => {
        return d.seatId;
      });
    });
  };

  const seatId = (array) => {
    return array.map((e) => {
      return e.id;
    });
  };
  const addToSeatList = (value) => {
    if (seatList.includes(value)) {
      return setSeatList(seatList.filter((item) => item !== value));
    }
    return setSeatList([...seatList, value]);
  };

  const occupySeats = [...availableSeats];

  const goingDutch = (availSeats) => {
    const remainingSeatsToDutch = differenceWith(seatId(props.seat.seats.filter((e) => e.open)), availSeats, isEqual);
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      employeeCard: props.userInfo.employeeCard,
      checkHeaderId: props.seat.id,
      stages: [
        {
          name: '',
          seatIds: [remainingSeatsToDutch[0]]
        }
      ]
    };
    return remainingSeatsToDutch.length > 0 && props.addToStage(dataToSend).then((response) => {
      occupySeats.push(response[0].seats[0].seatId);
      props.updateWithPaymentStages(response).then(() => {
        return remainingSeatsToDutch.length > 0 && goingDutch(occupySeats);
      });
    }).catch((err) => {
      props.setErrorPopUp({
        res: err.message
      })
    });
  };

  const renameStage = (data) => {
    if (data == '') return;
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      employeeCard: props.userInfo.employeeCard,
      checkHeaderId: props.seat.id,
      stages: [
        {
          paymentStageId: tempObject.id,
          name: data
        }
      ]
    };
    props.renameToStage(dataToSend).then((res) => {
      props.setSeat(res);
      setIsEditModalOpen(false);
    }).catch((err) => {
      props.setErrorPopUp({
        res: err.message
      })
    });
  };

  const clearAll = (paymentStages) => {
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      employeeCard: props.userInfo.employeeCard,
      checkHeaderId: props.seat.id,
      stages: [
        {
          paymentStageId: paymentStages && paymentStages[0] && paymentStages[0].id,
        }
      ]
    };
    return paymentStages.length > 0 && props.deleteStage(dataToSend).then(() => {
      const index = findIndex(paymentStages, (e) => e.id === paymentStages[0].id);
      paymentStages.splice(index, 1);
      props.removeWithPaymentStages(paymentStages[0]).then(() => {
        return paymentStages.length > 0 && clearAll(paymentStages);
      });
    }).catch((err) => {
      props.setErrorPopUp({
        res: err.message
      })
    });
  };

  const handleStageMove = () => {
    setMoveModalOpen(true);
  };

  const handleCheckItems = (data, isCheck, index) => {
    tableData.paymentStages[selectedStage].items[index] = {
      ...data,
      isCheck
    };
    setTableData({
      ...tableData
    });
    setSelectedItem({});
  };

  const handleCardSelection = (data) => {
    if (selectedSeats.indexOf(data) === -1 && selectedSeats.includes('allStages')) {
      setSelectedSeats([data]);
    } else if (selectedSeats.indexOf(data) === -1 && !selectedSeats.includes('allStages')) {
      setSelectedSeats(selectedSeats.concat(data));
    } else {
      setSelectedSeats(selectedSeats.filter((x) => x !== data));
    }
    if (data === 'allStages') {
      setSelectedSeats(['allStages']);
    }
  };

  const handleStageSelection = (data) => {
    setTableData({
      ...tableData,
      paymentStages: seatItemHashTable
    });
    if (selectedStage !== data.id) {
      setSelectedStage(data.id);
    } else {
      setSelectedStage('');
    }
  };

  const handleItemSelection = (data) => {
    setTableData({
      ...tableData,
      paymentStages: seatItemHashTable
    });
    if ([selectedItem].some((e) => e.id !== data.id)) {
      setSelectedItem(data);
    } else {
      setSelectedItem({});
    }
  };

  const getSelectedStageSeatIds = () => {
    return selectedSeats.reduce((a, v) => {
      if (v.seats.length > 0) {
        a.push(...v.seats.map((e) => e.seatId));
      }
      return a;
    }, []);
  };

  const getCheckItemSeats = () => {
    return tableData.paymentStages[selectedStage].items.reduce((a, v) => {
      if (v.isCheck) {
        a.push({
          checkItemId: v.id
        });
      }
      return a;
    }, []);
  };

  const checkItemSeat = () => {
    if (selectedItem.service || selectedItem.discount) {
      return [];
    }
    return tableData.paymentStages[selectedStage].items.filter((e) => e.isCheck).length > 0 ? getCheckItemSeats() : [{ checkItemId: selectedItem.id }];
  };

  const submitMove = () => {
    const datatosend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: props.seat.id,
      employeeCard: props.userInfo.employeeCard,
      seatIds: selectedSeats.includes('allStages') ? [] : getSelectedStageSeatIds(),
      checkItemSeats: checkItemSeat(),
      checkDiscountSeats: selectedItem.discount ? [{ checkDiscountId: selectedItem.id }] : [],
      checkServiceChargeSeats: selectedItem.service ? [{ checkServiceChargeId: selectedItem.id }] : []
    };
    props.moveChecks(datatosend).then((res) => {
      props.updateChecksAfterResponse(res);
      props.setSeat(res);
      setSelectedItem([]);
    }).catch((err) => {
      props.setErrorPopUp({
        res: err.message
      })
    });
  };

  const handleConfirmStageSplit = () => {
    props.setConfirmStageSplit(true);
    props.history.replace(({ pathname: `${APP_CONFIG.BASE_URL}/stagepayment/${seat.id}` }));
  };

  const stagePayment = () => {
    if (props.seat.paymentStages.length === 0) {
      props.setNotification({
        type: 'danger',
        message: CUSTOM_MESSAGES().NO_STAGE_MSG
      });
    } else if (props.seat.unpaidAmount === 0) {
      props.setNotification({
        type: 'danger',
        message: CUSTOM_MESSAGES().NO_ITEM_MSG
      });
    } else if ((props.auth?.loyaltyInfo?.suppressOfferOnSplitByPerson && false) && tableData?.stageItemsArray.some((item) => item.splitValue > 1)) {
      setIsConfirmStageSplitModal(true);
    } else {
      props.history.replace(({ pathname: `${APP_CONFIG.BASE_URL}/stagepayment/${seat.id}` }));
    }
  };

  const addStage = () => {
    if (seatList.length === 0) {
      props.setNotification({
        type: 'danger',
        message: CUSTOM_MESSAGES().PLEASE_SELECT_SEAT
      });
    } else {
      const dataToSend = {
        storeId: props.deviceInfo.storeId,
        deviceId: props.deviceInfo.deviceId,
        employeeId: props.userInfo.id,
        employeeCard: props.userInfo.employeeCard,
        checkHeaderId: props.seat.id,
        stages: [
          {
            name: '',
            seatIds: seatList
          }
        ]
      };
      props.addToStage(dataToSend).then((response) => {
        setSeatList([]);
        props.updateWithPaymentStages(response);
      }).catch((err) => {
        props.setErrorPopUp({
          res: err.message
        })
      });
    }
  };


  const editStage = () => {
    setStageIsModalOpen(true);
  }

  const closeModal = () => {
    setStageIsModalOpen(false);
  }

  const handleClear = (data) => {
    if (props.cart.filter((e) => (e.seatIds.includes(data.id)) && e.pending).length > 0) {
      props.setNotification({
        type: 'danger',
        message: ERROR_MESSAGE.SEND_PENDING_ITEMS,
      });
    } else {
      const dataToSend = {
        storeId: props.deviceInfo.storeId,
        employeeId: Number(props.userInfo.id),
        employeeCard: props.userInfo.employeeCard,
        deviceId: props.deviceInfo.deviceId,
        checkHeaderId: props.seat.id,
        stationId: props.seat.stationId || null,
        seats: [{
          seatId: data.id
        }]
      };
      props.seatClear(dataToSend).then((res) => {
        props.updateSeatInfo(res);
        props.setSeat(res);
        props.setPosition({ number: -1, position: -1 });
        closeModal();
      }).catch((err) => {
        props.setErrorPopUp({
          res: err.message
        })
      });
    }
  };

  const submitSeatNumber = (val) => {
    const seatArray = [];
    if (Array.isArray(val)) {
      val.forEach((e) => {
        seatArray.push({
          number: e,
          tableShareType: 0
        });
      });
    } else {
      seatArray.push({
        number: val,
        tableShareType: 0
      });
    }
    const cb = () => {
      const dataToSend = {
        storeId: props.deviceInfo.storeId,
        deviceId: props.deviceInfo.deviceId,
        employeeId: Number(props.userInfo.id),
        employeeCard: props.userInfo.employeeCard,
        checkHeaderId: props.seat.id,
        seats: seatArray
      };
      props.occupySeat(dataToSend).then((response) => {
        props.updateChecksAfterResponse(response);
        const seatsData = filter((response.seats), (seat) => seat.open);
        const positionReq = find(seatsData, (seat) => seat.position === Number(dataToSend.seats[0].position));
        const seatReq = {
          ...response,
          seats: sort(response.seats, 'number')
        };
        props.setPosition(positionReq);
        props.updateSeatInfo(seatReq);
        closeModal();
      }).catch((err) => {
        props.setErrorPopUp({
          res: err.message
        })
      });
    };
    addInProcessItemsToCart(cb);
  };

  const getFilteredOutModifiersFromParentItem = (CartItems = []) => {
    return CartItems.reduce((a, v) => {
      const obj = { ...v };
      if (v.hasLinkedMenuItem) {
        obj.modifiers = [];
      }
      a.push(obj);
      return a;
    }, []);
  };


  const addInProcessItemsToCart = (cb) => {
    const inProcessItem = props.cart.filter((e) => e.isProcessing);
    setLoader(true);
    const dataToSendToAdd = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: Number(props.userInfo.id),
      employeeCard: props.userInfo.employeeCard,
      checkHeaderId: props.seat.id,
      stationId: props.seat.stationId,
      items: inProcessItem,
      orderJson: JSON.stringify([...inProcessItem]),
      longitude: '0',
      latitude: '0',
      geoLocation: '0'
    };
    if (inProcessItem?.length > 0) {
      props.addChecks(dataToSendToAdd, 'add').then((res) => {
        props.updateSeatInfo(res);
        const ItemsArray = res.orders[0]?.items || [];
        if (ItemsArray?.length > 0) {
          const CartItems = [];
          ItemsArray.forEach((item) => {
            if (item.pending && item.itemType !== 'D') {
              const cartData = {
                ...JSON.parse(JSON.parse(item?.orderJson)?.modifierJson),
                isProcessing: false,
                modifierJson: JSON.parse(item?.orderJson)?.modifierJson,
                id: item.id,
                checkItemId: item.checkItemId,
              };
              CartItems.push(cartData);
            }
          });
          props.replaceCart(CartItems);
          setLoader(false);
          const filteredCart = getFilteredOutModifiersFromParentItem(CartItems);
          if (cb) {
            cb(filteredCart, res);
          }
        }
      });
    } else {
      setLoader(false);
      const filteredCart = getFilteredOutModifiersFromParentItem(props.cart);
      if (cb) {
        cb(filteredCart, props.check);
      }
    }
  };

  const removeFromStage = () => {
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      employeeCard: props.userInfo.employeeCard,
      checkHeaderId: props.seat.id,
      stages: [
        {
          paymentStageId: tempObject.id,
        }
      ]
    };
    props.deleteStage(dataToSend).then(() => {
      props.removeWithPaymentStages(tempObject);
      setModalOpen(false);
    }).catch((err) => {
      props.setErrorPopUp({
        res: err.message
      })
    });
  };

  const handleConfirmSplit = () => {
    setIsConfirmSplit(false);
    //veer
    props.history.replace(({ pathname: `${APP_CONFIG.BASE_URL}/receipt/${tableData.id}?ticketSplitTypeId=3&splitValue=1&screenType=9&type=split&source=stageSplit` }));
  }

  const stageBtn = [
    { name: CUSTOM_MESSAGES().Edit_seat ? CUSTOM_MESSAGES().Edit_seat : LABEL().Edit_seat, click: () => editStage() },
    { name: LABEL().CLEAR_ALL, click: () => clearAll(props.seat.paymentStages) },
    { name: LABEL().STAGE, click: () => addStage() },
    { name: LABEL().GOING_DUTCH, click: () => goingDutch(availableSeats) },
    { name: LABEL().SPLIT_EVENLY, click: () => props.auth?.loyaltyInfo?.supportsLoyalty || props.auth?.loyaltyInfo?.supportsCoupon ? setIsConfirmSplit(true) : handleConfirmSplit() },
  ];
  const popUpBtn = [
    { name: LABEL().YES, click: () => removeFromStage() },
    { name: LABEL().NO, click: () => setModalOpen(false) }
  ];

  const handleMove = () => {
    setMoveModalOpen(false);
    submitMove();
    setCardIndex([]);
    setSelectedSeats([]);
  };

  const handleCancel = () => {
    setMoveModalOpen(false);
    setCardIndex([]);
    setSelectedSeats([]);
  };

  // HTML CSS CODE

  return (
    <>
      {(loader || props.loading) && <Loader message={loader ? 'Updating item' : ''} serverAppTheme={serverAppTheme} />}
      {isStageModalOpen && (
        <FullWithModal
          isOpen={isStageModalOpen}
          loading={props.loading}
          isModalCenter
          customClass2={cn("w-100 h-100 p-3")}
          noBackground
          style={{ position: 'relative', display: 'flex', flexDirection: 'column', width: '100%', pointerEvents: 'auto', backgroundClip: 'padding-box', height: '100%', borderRadius: "16px", backgroundColor: serverAppTheme?.popUp_bg, border: serverAppTheme?.popupBorder, boxShadow: serverAppTheme?.popUp_box_shadow }}
        >
          <div className="col-12 justify-content-center align-items-center position-relative text-center " style={{ color: serverAppTheme?.primary_text }}>
            <div className="position-absolute" style={{ right: '8px', top: '0' }}>
              <Cross fill={serverAppTheme?.iconcolor} onClick={() => setStageIsModalOpen(false)} style={{ width: '28px', height: '28px' }} />
            </div>
            <div className='col-11 ml-5 fs_18 h-10 d-flex align-items-center justify-content-center fw-600'>{LABEL().ADD_SEAT}</div>
            <KeyboardForOrder
              name="seatNumber"
              type="numericWithdone"
              placeholder={CUSTOM_MESSAGES().ENTER_SEAT_NUMBER}
              isOpen={isStageModalOpen}
              customClass="mt-2"
              footerBtns={true}
              specialValue=""
              check={props.seat}
              buttonName={LABEL().OCCUPY_SEAT}
              onSubmit={submitSeatNumber}
              closeModal={() => setStageIsModalOpen(false)}
              isKeyboardHide={true}
              isEditSeatPopUp={true}
              serverAppTheme={serverAppTheme}
              screenType={'occupySeat'}
            />
          </div>
        </FullWithModal>
      )}
      {isClearPopUp?.isOpen && (
        <Modal isOpen={isClearPopUp?.isOpen} isModalCenter noBackground style={{ width: '418px', minHeight: '222px', backgroundColor: serverAppTheme?.popUp_bg, border: serverAppTheme?.popupBorder, boxShadow: serverAppTheme?.popUp_box_shadow, borderRadius: '16px', margin: 'auto' }}>
          <div className="col-12 my-4 justify-content-center align-items-center position-relative text-center " style={{ color: serverAppTheme?.primary_text }}>
            <div className="col-12 fs-20  mt-10 fw-700 text-center">
              <div>Are you sure?</div>
            </div>
            <div className="col-12 fs-16  mt-10 fw-500 text-center">
              <div>{CUSTOM_MESSAGES().CLEAR_ALL_FROM_SEAT}</div>
            </div>
            <div className="col-12 mt-4 d-flex justify-content-center">
              <button
                type="submit"
                className={cn(style.noBtn, "col-6 m-2")}
                onClick={() => setClearPopUp({ isOpen: false, data: [] })}
                style={{ border: serverAppTheme?.cancleBtn_Border, background: serverAppTheme?.OFF_Premise_Btn, color: serverAppTheme?.cancleBtn_font }}
              >
                <div className="fs-28 fw-600">{LABEL().NO}</div>
              </button>
              <button
                type="submit"
                className={cn(style.yesBtn, "col-6 m-2")}
                onClick={() => {
                  setClearPopUp({ isOpen: false, data: [] });
                  handleClear(isClearPopUp.data);
                }}
                style={{ backgroundColor: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color }}
              >
                <div className="fs-28 fw-600">{LABEL().YES}</div>
              </button>
            </div>
          </div>
        </Modal>
      )}
      <Modal
        isOpen={isConfirmSplit}
        isModalCenter
        noBackground
        style={{ background: serverAppTheme?.popUp_bg, border: '1px solid #626262', borderRadius: "16px" }}
      >
        <div className="col-12 my-2 px-0 justify-content-center align-items-center position-relative text-center od-text-primary text-white">
          <div className="px-2 text-right fs-28">
            <i
              onClick={() => { setIsConfirmSplit(false); }}
              role="presentation"
              className="fa fa-times"
              aria-hidden="true"
              style={{ color: serverAppTheme?.primary_text }}
            />
          </div>
          <div className="col-12 fs-16 fw-400 text-center" style={{ color: serverAppTheme?.primary_text }}>
            {CUSTOM_MESSAGES().CONFIRM_SPLIT}
          </div>
          <div className="col-12 d-flex justify-content-center">
            <button type="submit" className={cn('col-4 m-2 btn od-btn-secondary', style.noBtn)} onClick={() => setIsConfirmSplit(false)} style={{ border: serverAppTheme?.cancleBtn_Border, background: serverAppTheme?.OFF_Premise_Btn, color: serverAppTheme?.cancleBtn_font }}>
              <div className="fs-28">{LABEL().NO}</div>
            </button>
            <button type="submit" className={cn('col-4 m-2 btn btn-ripple btn-lg od-btn-primary', style.yesBtn)} onClick={() => { handleConfirmSplit(); }} style={{ backgroundColor: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color }}>
              <div className="fs-28">{LABEL().YES}</div>
            </button>
          </div>
        </div>
      </Modal>
      <div className={cn(style.cross_icon, 'position-fixed text-white fs-18 d-flex justify-content-center align-items-center rounded')} style={{ width: '1.85rem', height: '1.85rem', backgroundColor: serverAppTheme.iconcolor_bg_box }}>
        <Cross fill={serverAppTheme?.iconcolor} width={24} height={24} onClick={() => props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`)} />
      </div>
      {props.loading && <Loader />}
      <StageComp
        tableData={{ ...tableData }}
        currencySymbol={currencySymbol}
        stageBtn={stageBtn}
        seatList={seatList}
        popUpBtn={popUpBtn}
        isModalOpen={isModalOpen}
        setModalOpen={setModalOpen}
        isEditModalOpen={isEditModalOpen}
        setIsEditModalOpen={setIsEditModalOpen}
        addToSeatList={addToSeatList}
        availableSeats={availableSeats}
        stagePayment={stagePayment}
        setTempObject={setTempObject}
        removeFromStage={removeFromStage}
        countryCode={countryCode}
        handleStageMove={handleStageMove}
        handleStageSelection={handleStageSelection}
        cardIndex={cardIndex}
        handleCheckItems={handleCheckItems}
        selectedStage={selectedStage}
        handleItemSelection={handleItemSelection}
        selectedItem={selectedItem}
        seat={seat}
        setSeatDeleteModal={setSeatDeleteModal}
        serverAppTheme={serverAppTheme}
      />
      <FullWithModal
        isOpen={isMoveModalOpen}
        customClass2={cn("w-100 h-100 p-3")}
        noBackground
        style={{ position: 'relative', display: 'flex', flexDirection: 'column', width: '100%', pointerEvents: 'auto', backgroundClip: 'padding-box', height: '100%', borderRadius: "16px", backgroundColor: serverAppTheme?.popUp_bg, border: serverAppTheme?.popupBorder, boxShadow: serverAppTheme?.popUp_box_shadow }}
      >
        <div className='col-12' style={{ margin: 'auto', color: serverAppTheme?.primary_text }}>
          <div className="p-1 position-absolute" style={{ right: '6px', top: '3px' }}>
            <div className="" role="presentation" onClick={() => { handleCancel() }}>
              <Cross fill={serverAppTheme?.iconcolor} style={{ width: '28px', height: '28px' }} />
            </div>
          </div>
          <div className="col-10 py-4 my-10 justify-content-center align-items-center position-relative text-center " style={{ margin: 'auto' }}>
            <div style={{ height: '40px' }} />
            <div className={cn('col-12 col-md-12 p-1 w-100 align-items-center')} style={{ maxHeight: '40vh', overflow: 'auto', display: 'grid' }}>
              <div className={cn('row flex-row p-0 mx-0 overflowY overflowXHidden')}>
                {tableData.paymentStages && Object.values(tableData.paymentStages).map((item) => {
                  return Number(item.status) === 0 && (
                    <div
                      key={item.id}
                      role="presentation"
                      onClick={() => handleCardSelection(item)}
                      className={cn('col-4 px-1 py-1 mx-0 my-1')}
                    >
                      <div className={cn('h-100 od-container-card-border p-1 rounded', selectedSeats.some((e) => e.id === item.id) ? ` ${style.moveSelectedStage}` : style.moveUnselectedStage)}
                        style={{ background: selectedSeats.some((e) => e.id === item.id) ? serverAppTheme?.selected : serverAppTheme?.stage_tab_button, border: selectedSeats.some((e) => e.id === item.id) ? 'none' : `1px solid ${serverAppTheme?.stage_seat_border}`, color: selectedSeats.some((e) => e.id === item.id) ? 'white' : serverAppTheme?.primary_text }}>
                        <div className="d-flex align-items-center justify-content-center">
                          <div className="col d-flex fs_12 fw-400 py-0 m-0 px-0 align-items-center">
                            <div className="col px-0 m-0 overflowX">
                              <div className="d-flex rounded">
                                {item.seats && item.seats.map((data, index) => {
                                  const seatObj = tableData.seats.find((e) => e.id === data.seatId);
                                  return seatObj && (
                                    <div key={data.id} style={{ height: '32px', background: serverAppTheme?.stage_table_number, color: selectedSeats.some((e) => e.id === item.id) ? '#000' : 'white' }} className={cn('rounded  fs_18 mr-1', style.seatStaged, selectedSeats.some((e) => e.id === item.id) ? '' : '')}>
                                      {seatObj.number}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                            <label className=" col-5 fs_16 m-0 p-0" style={{ textAlign: 'end' }}>{item.totalAmount ? `${currencySymbol}${Number(item.totalAmount).toFixed(2)}` : ''}</label></div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="col-12 d-flex mt-2 p-1 justify-content-center">
              <div
                role="presentation"
                className={cn(' w-100')}
                onClick={() => handleCardSelection('allStages')}
              >
                <div className={cn('justify-content-center align-items-center rounded  fs_32 fw-600 text-center text-white d-flex', style.divForPayment, selectedSeats.includes('allStages') ? '' : '')} style={{ height: '13vh', minHeight: '45px', backgroundColor: selectedSeats.includes('allStages') ? serverAppTheme?.primaryBtn : serverAppTheme?.primary_btn_disable, color: 'white' }}>
                  {LABEL().ALL_STAGES}
                </div>
              </div>
            </div>
            <div style={{ height: '40px' }} />
          </div>
          <div className="col-10 d-flex justify-content-center mt-2 m-auto">
            <div className="col-12 d-flex mt-2 justify-content-center">
              <div className='col-6 pr-1 pl-0'>
                <button type="button" className="fs_24 fw-600 btn-ripple w-100 p-0 d-flex align-items-center justify-content-center" onClick={() => handleCancel()} style={{ background: serverAppTheme?.OFF_Premise_Btn, border: serverAppTheme?.cancleBtn_Border, color: serverAppTheme?.cancleBtn_font, height: '13vh', borderRadius: '3px' }}>
                  {LABEL().CANCEL}
                </button>
              </div>
              <div className='col-6 pl-1 pr-0'>
                <button
                  type="button"
                  style={{ background: selectedSeats.length === 0 ? serverAppTheme?.secondaryBtnDisabled : serverAppTheme?.secondaryBtn, color: selectedSeats.length === 0 ? serverAppTheme?.secondary_btn_disable_text : serverAppTheme?.btn_font_color, height: '13vh', border: '0', borderRadius: '3px' }}
                  className="w-100 btn-ripple fs_24 fw-600 d-flex align-items-center justify-content-center"
                  onClick={() => { handleMove(); }}
                  disabled={selectedSeats.length === 0}
                >
                  {LABEL().MOVE}
                </button>
              </div>
            </div>
          </div>
        </div>
      </FullWithModal>
      <Modal
        isOpen={isConfirmStageSplitModal}
        isModalCenter
      >
        <div className="col-12 my-2 px-0 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
          <div className="px-2 text-right fs-24">
            <i
              onClick={() => { setIsConfirmStageSplitModal(false); }}
              role="presentation"
              className="fa fa-times"
              aria-hidden="true"
            />
          </div>
          <div className="col-12 fs-18 fw-700 text-center">
            {CUSTOM_MESSAGES().CONFIRM_STAGE_WITH_SPLIT}
          </div>
          <div className="col-12 d-flex justify-content-center">
            <button type="submit" className="col-4 m-2 btn btn-secondary od-btn-secondary" onClick={() => setIsConfirmStageSplitModal(false)}>
              <div className="fs-18">{LABEL().NO}</div>
            </button>
            <button type="submit" className="col-4 m-2 btn btn-primary btn-ripple btn-lg od-btn-primary" onClick={() => { handleConfirmStageSplit(); }}>
              <div className="fs-18">{LABEL().YES}</div>
            </button>
          </div>
        </div>
      </Modal>
      <FullWithModal
        isOpen={isEditModalOpen}
        customClass2={cn("w-100 h-100 p-3")}
        noBackground
        style={{ position: 'relative', display: 'flex', flexDirection: 'column', width: '100%', pointerEvents: 'auto', backgroundClip: 'padding-box', height: 'fit-content', borderRadius: "16px", marginTop: '4vw', backgroundColor: serverAppTheme?.popUp_bg, border: serverAppTheme?.popupBorder, boxShadow: serverAppTheme?.popUp_box_shadow, }}
      >
        <div className="col-12 py-3 justify-content-center align-items-center position-relative text-center od-text-primary text-white">
          <div
            className="text-right"
            style={{ position: "absolute", top: "10px", right: "10px", zIndex: "999" }}
          >
            <Cross fill={serverAppTheme?.iconcolor} onClick={() => setIsEditModalOpen(false)} style={{ width: '28px', height: '28px' }} />
          </div>
          {isEditModalOpen && (
            <KeyboardForOrder
              name="stageName"
              type="textWithoutNumeric"
              customClass="mt-2"
              specialValue={tempObject.name ? String(tempObject.name) : ''}
              placeholder={CUSTOM_MESSAGES().ENTER_STAGE_NAME}
              buttonName={LABEL().SUBMIT}
              onSubmit={renameStage}
              editSeatPopUP={true}
              noBtnclass={true}
              serverAppTheme={serverAppTheme}
              setErrorPopUp={props.setErrorPopUp}
            />
          )}
        </div>
      </FullWithModal>
      <FullWithModal isOpen={isSeatDeleteModal} customClass={cn('h-100')} customClass2={cn("w-100 h-100 p-3")} style={{ position: 'relative', display: 'flex', flexDirection: 'column', width: '100%', pointerEvents: 'auto', backgroundClip: 'padding-box', height: '100%', borderRadius: "16px", backgroundColor: serverAppTheme?.popUp_bg, border: serverAppTheme?.popupBorder, boxShadow: serverAppTheme?.popUp_box_shadow }} noBackground>
        <>
          <div
            className="position-absolute text-white" role="presentation"
            onClick={() => { setSeatDeleteModal(false); setSelectedSeat(); }}
            style={{ right: '7px', top: '5px', zIndex: "999" }}
          >
            <Cross fill={serverAppTheme?.iconcolor} style={{ width: '28px', height: '28px' }} />
          </div>
          <div className="col-12 h-100 justify-content-center align-items-center position-relative text-center" style={{ color: serverAppTheme?.primary_text }}>
            <div className='col-12 fs_18 h-10 d-flex align-items-center justify-content-center fw-600'>{LABEL().SELECT_A_SEAT_TO_DELETE}</div>
            <div className={cn('col-12 px-0 large-input m-auto justify-content-center h-90 position-relative')}>
              <div className={cn('col-12 row p-0 mx-0 mt-2 flex-wrap overflowY w-100 h-80', style.wrapper)} style={{ margin: '1rem auto' }}>
                {tableData?.seats && tableData?.seats.filter((e) => e.open).length > 0 && tableData.seats.map((item) => {
                  return !availableSeats.includes(item.id) && item.open && (
                    <div className='w-100'>
                      {item.open && (
                        <div
                          className={cn(
                            style.btnBorderWhiteStageDelete,
                            selectedSeat && selectedSeat.id === item.id
                              ? `${style.selectedSeats}`
                              : `${style.unSelectedSeats}`,
                            "d-flex justify-content-center align-items-center rounded mr-1 mb-1 fs_32",
                          )}
                          style={{
                            color: selectedSeat?.id === item.id ? "#000" : serverAppTheme?.primary_text,
                            border: selectedSeat?.id === item.id ? "none" : serverAppTheme?.popupBorder,
                            background:
                              selectedSeat?.id === item.id
                                ? serverAppTheme?.selected
                                : serverAppTheme?.unselected,
                          }}
                          tabIndex="0"
                          role="button"
                          onClick={() => setSelectedSeat(item)}
                        >
                          {item.number}
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>
              <div style={{ left: '0' }} className='col-12 h-10 px-0 d-flex justify-content-center align-items-center w-100 position-absolute'>
                <button
                  className={cn('w-50 mt-2 btn  btn-ripple ')}
                  type="button"
                  onClick={() => { setClearPopUp({ isOpen: true, data: selectedSeat }); setSeatDeleteModal(false); }}
                  disabled={!selectedSeat}
                  style={{ height: '8.5vh', backgroundColor: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color, border: 'none', borderRadius: '4px' }}
                >
                  <div className="fs_24 fw-600">{LABEL().DELETE_SEAT}</div>
                </button>
              </div>
            </div>
          </div>

        </>
      </FullWithModal>
    </>
  );
};

// Redux Part

const mapStateToProps = state => ({
  deviceInfo: state.oauth.deviceInformation,
  userInfo: state.oauth.loggedInUserData,
  auth: state.oauth.authInfo,
  seat: state.orders.seats,
  position: state.orders.position,
  loading: state.stage.loading || state.orders.loading || state.storeChecks.loading,
  cart: state.orders.cart,
  serverAppTheme: state.theme.serverAppTheme,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  addToStage,
  renameToStage,
  moveChecks,
  updateChecksAfterResponse,
  deleteStage,
  setSeat,
  setNotification,
  stopNotificationSound,
  updateWithPaymentStages,
  removeWithPaymentStages,
  setConfirmStageSplit,
  setPosition,
  seatClear,
  updateSeatInfo,
  occupySeat,
  addChecks,
  replaceCart,
  setErrorPopUp
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Stage);
